// extracted by mini-css-extract-plugin
module.exports = {"container":"CookieConsent_container__l6BHH"};